import { Avatar, Card, Stack } from '@mui/material';
import * as React from 'react';
import MenuCardWidget from '../../../../../../widgets/MenuCard';
import { getFilesArchivos } from '../../../../../archivos/HelpersArchivos';

const CardEstudiantesReprobados = ({ estudiante, tipoSearch }) => {
  return (
    <Card
      elevation={4}
      sx={{
        width: tipoSearch === 1 ? '47%' : '100%',
        height: '190px',
        mb: 1,
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          fontSize: 14,
          backgroundColor: 'white',
          p: 1,
          borderRadius: 2,
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <Avatar
          alt={estudiante.usuario.perfil.pnombre}
          sx={{ width: 70, height: 70 }}
          src={getFilesArchivos(estudiante.usuario.perfil.avatar)}
        />
        <strong>
          {estudiante.usuario.perfil.pnombre}
          <br />
          {estudiante.usuario.perfil.papellido}
        </strong>
        {estudiante.usuario.perfil.tipoDni}-{estudiante.usuario.perfil.dni}
        <br />
        <label style={{ fontWeight: 'bold', color: 'red', fontSize: '18pt' }}>
          {tipoSearch === 1
            ? Number(estudiante.nota) < 10
              ? '0' + estudiante.nota.replace('0', '')
              : estudiante.nota
            : Number(estudiante.definitiva) < 10
            ? '0' + estudiante.definitiva.replace('0', '')
            : estudiante.definitiva}
        </label>
        <MenuCardWidget onAsign={() => {}} />
      </Stack>
    </Card>
  );
};

export default CardEstudiantesReprobados;
